// const AUTH_API_URL = "";

export default {
  namespaced: true,
  state: {
    user: {},
    accessToken: null,
    refreshToken: null
  },
  getters: {
    loggedIn: state => state.accessToken
  },
  actions: {
    load: ({ state }) => {
      const userString = localStorage.getItem("user");
      if (userString) state.user = JSON.parse(userString);

      const accessString = localStorage.getItem("accessString");
      if (accessString) state.accessToken = accessString;

      const refreshString = localStorage.getItem("refreshToken");
      if (refreshString) state.accessToken = refreshString;
    }
  }
};
